import * as Types from '../../constants/actionTypes';

export default (state = {}, action) => {
    switch (action.type) {
        case Types.PORTAL_QRCODE_DATA: {
            return {
                ...state,
                qrCodeRequests: action.qrCodeRequests,
            };
        }
        case Types.ADD_RECURSIVE_REQUEST: {
            return {
                ...state,
                recursiveRequest: action.payload,
            }
        }
        case Types.GET_PROGRAM_RECURSIVE_REQUEST: {
            return {
                ...state,
                programRecursiveRequest: action.payload,
            }
        }
        case Types.NUMBER_REQUEST_EACH_SERVICE_TYPE: {
            return {
                ...state,
                numRequestEachType: action.numRequestEachType,
            }
        }
        case Types.List_NEW_REQUESTS: {
            return {
                ...state,
                listNewRequests: action.listNewRequests,
            }
        }
        case Types.RECURSIVE_REQUEST_ERROR: {
            return {
                ...state,
                recursiveRequestError: action.error,
            }
        }

        default:
            return state;
    }
};
